import { differenceInSeconds, format, formatDistance } from "date-fns";
import i18n from "@/plugins/i18n.js";
import { sv } from "date-fns/locale";

export default {
  methods: {
    humanDate(date, formatString = undefined) {
      if (date == "0001-01-01T00:00:00") return "N/A";
      return date !== undefined && date !== null
        ? format(
            typeof date === "string" ? new Date(date) : date,
            formatString !== undefined ? formatString : "dd MMM - HH:mm"
          )
        : "N/A";
    },

    timeFromDays(days) {
      return days * 24 * 60 * 60 * 1000;
    },

    timeFromHours(hours) {
      return hours * 60 * 60 * 1000;
    },

    timeFromMinutes(minutes) {
      return minutes * 60 * 1000;
    },

    timeWithinMinutes(date1, minutes, date2) {
      if (date2 == undefined) date2 = new Date();
      return date2 - new Date(date1) < this.timeFromMinutes(minutes);
    },

    timeWithinHours(date, hours) {
      return new Date() - new Date(date) < this.timeFromHours(hours);
    },

    timeWithinDays(date, days) {
      return new Date() - new Date(date) < this.timeFromDays(days);
    },

    distanceAgo(date) {
      if (date == null) return "";

      let options = {};
      if (i18n.locale == "sv") options = { locale: sv };

      return formatDistance(new Date(date), new Date(), options);
    },

    differenceInSeconds(date1, date2) {
      date1 = new Date(date1);
      date2 = new Date(date2);
      return date1 == undefined || date2 == undefined
        ? NaN
        : differenceInSeconds(date1, date2);
    },

    toApiDate(date, encode = false) {
      let dt = this.humanDate(date, "yyyy-MM-dd HH:mm:ss");

      return encode ? encodeURIComponent(dt) : dt;
    },
  },
};
